module.exports = __webpack_public_path__ + "static/media/sun-cloud.1faf7d86.svg";